import { AppointmentType } from 'constants/appointmentType'
import { Typography } from '@mui/material'
import { getCabinResource } from 'components/Appointment/util'
import { useAppointmentTypeTranslation } from 'components/Appointment/util/useAppointmentTypeTranslation'
import { ReactNode, VFC } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppointment, useUserSettings } from '../../hooks'
import { appointmentTypeToDisplayText } from '../../util'
import { getSpecialistResource } from '../Appointment/util'
import { Spacer } from '../Spacer'

const fallbackTimeZone = 'America/Denver'

const toShortTimeZonedDateText = (date: Date, locale: string, timeZone: string) => {
  const formatter = Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
    timeZoneName: 'short',
    hourCycle: 'h12',
  })

  return formatter.format(date)
}

const AppointmentInfo: VFC = () => {
  const { locale } = useUserSettings()
  const { t } = useTranslation()
  const { appointment } = useAppointment()

  let details: ReactNode = <>&nbsp;</>
  let dateText: ReactNode = <>&nbsp;</>

  const appointmentParams = {
    appointmentType: appointmentTypeToDisplayText[appointment?.type.appointment_type ?? AppointmentType.HEARING_AID_EVALUATION],
    fitterName: getSpecialistResource(appointment?.resources)?.name,
    cabinName: getCabinResource(appointment?.resources)?.name,
    shopId: appointment?.resources?.[0]?.shop_id,
  }

  const { getAppointmentTypeTranslation } = useAppointmentTypeTranslation(appointmentParams)

  if (appointment) {
    const customerTime = toShortTimeZonedDateText(
      appointment.start_date,
      locale,
      (appointment.scheduled_customer_timezone as string) ?? fallbackTimeZone
    )

    details = getAppointmentTypeTranslation()
    dateText = t('common.label.timeWithCustomerTimeSuffix', { customerTime, customerTimeText: t('common.label.customerTime') })
  }

  return (
    <>
      <Typography variant="h3">{details}</Typography>
      <Spacer count={0.25} />
      <Typography variant="h3">{dateText}</Typography>
    </>
  )
}

export { AppointmentInfo }
